import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from "currency-symbol-map";
import {
  getDivisor,
  getFeatures,
  getValidityText,
} from "../../../../utils/stripe-helpers";

const IconRow = ({ text }) => {
  return <p className="p4">{text}</p>;
};

const PlanDetails = ({ selectedPlan }) => {
  const { t } = useTranslation("coaching-portal");
  const features = getFeatures(selectedPlan);
  const { currency, unit_amount, nickname, recurring } = selectedPlan;
  const amount = unit_amount / getDivisor(currency);
  return (
    <article className="plan-card bordered-card">
      <h3 style={{ marginBottom: 16 }}>{nickname}</h3>
      <IconRow text={getValidityText(recurring)} />
      <IconRow text={t("membershipList.unusedTimeUpgrade")} />
      {features &&
        features.map((feature) => <IconRow key={feature} text={feature} />)}

      <h1>
        <sup>{getSymbolFromCurrency(currency)}</sup>
        {Number(amount).toLocaleString()}
      </h1>
    </article>
  );
};

export default PlanDetails;
